import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Terms & conditions", -1)
const _hoisted_2 = { class: "checkout-terms" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.islesofscilly-travel.co.uk/plan-your-trip/terms-and-conditions-and-faqs/",
  target: "_blank"
}, "View terms and conditions", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, {
    errors: _ctx.v$.$errors
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseCheckbox, {
          id: 'terms',
          name: 'terms',
          label: _ctx.terms,
          modelValue: _ctx.v$.termsAccepted.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.termsAccepted.$model) = $event)),
          hasError: _ctx.v$.termsAccepted.$error,
          valid: !_ctx.v$.termsAccepted.$invalid
        }, null, 8, ["label", "modelValue", "hasError", "valid"]),
        _hoisted_3
      ])
    ]),
    _: 1
  }, 8, ["errors"]))
}